import type { FC } from "react";

import type { PRODUCT_GRADIENTS } from "@jti/ui/components/FlavourCarousel/components/FlavourCarouselCard/FlavourCarouselCard";
import { FlavourCarouselCard as FlavourCarouselCardUI } from "@jti/ui/components/FlavourCarousel/components/FlavourCarouselCard/FlavourCarouselCard";
import type { FlavourProperties } from "@jti/ui/components/FlavourCarousel/components/FlavourRating/FlavourRating";

import type { flavourCarouselCardInputs } from "./FlavourCarouselCard.builder";

type FlavourCarouselCardBuilderProps = BuilderComponentProps<typeof flavourCarouselCardInputs>;

export const FlavourCarouselCard: FC<FlavourCarouselCardBuilderProps> = ({
  description,
  title,
  image,
  theme,
  backgroundColor,
  backgroundGradient,
  cta,
  flavours,
}) => {
  return (
    <FlavourCarouselCardUI
      backgroundColor={backgroundColor}
      description={description}
      image={image}
      theme={theme}
      title={title}
      backgroundGradient={backgroundGradient as keyof typeof PRODUCT_GRADIENTS}
      cta={cta}
      flavours={flavours?.map((flavour) => ({
        ...flavour,
        rating: flavour.rating as unknown as FlavourProperties["rating"],
      }))}
    />
  );
};
